export default class AppConstants {
  public static INVALID_LOGIN_DETAILS = 'Username or Password is incorrect.';
  public static DEFAULT_PAGE_SIZE = 10;
  public static DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 500];
  public static DEFAULT_PHOTOS_PAGE_SIZE = 25;
  public static get getRoles() {
    return [
      {
        label: 'Admin',
        value: 2
      },
      {
        label: 'Agency Admin',
        value: 4
      },
      {
        label: 'User',
        value: 64
      },
    ];
  }

  public static get enableLoaderException() {
    return [
      'adminLogin'
    ];
  }

  public static get disableLoaderException() {
    return [
      'organizations'
    ];
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/constants/AppConstants.ts